import { useState, useEffect } from 'react';
import { api } from '@/lib/api';

const badge = (s) => ({ Pending: 'bg-gold/15 text-gold-dark', Approved: 'bg-forest/10 text-forest', Scheduled: 'bg-forest/10 text-forest', Paid: 'bg-forest text-cream', 'Payment Issue': 'bg-red-50 text-red-600' }[s] || 'bg-dark/10 text-dark');

export default function FarmPayments() {
  const [data, setData] = useState({ payments: [], summary: { total_paid: 0, total_pending: 0 } });
  useEffect(() => { api.get('/farm/payments').then((r) => setData(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="farm-payments">
      <div className="grid grid-cols-2 gap-4 md:gap-6 mb-8 max-w-xl">
        <div className="bg-white rounded-2xl p-6 border border-forest/10"><p className="font-manrope text-sm text-dark/60">Pending</p><p className="font-playfair text-3xl font-bold text-gold-dark" data-testid="pay-pending">${data.summary.total_pending.toFixed(2)}</p></div>
        <div className="bg-white rounded-2xl p-6 border border-forest/10"><p className="font-manrope text-sm text-dark/60">Total paid</p><p className="font-playfair text-3xl font-bold text-forest" data-testid="pay-paid">${data.summary.total_paid.toFixed(2)}</p></div>
      </div>
      <div className="bg-white rounded-2xl border border-forest/10 overflow-hidden">
        {data.payments.length === 0 ? (
          <p className="p-12 text-center font-manrope text-dark/50">No payment records yet.</p>
        ) : (
          <table className="w-full text-left font-manrope text-sm">
            <thead className="bg-cream text-dark/60"><tr>{['Order', 'Pickup', 'Amount', 'Status', 'Method', 'Reference', 'Date'].map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}</tr></thead>
            <tbody className="divide-y divide-forest/10">
              {data.payments.map((p) => (
                <tr key={p.payment_id} data-testid={`payment-${p.payment_id}`}>
                  <td className="px-4 py-3 text-dark">{p.order_id}</td>
                  <td className="px-4 py-3 text-dark/70">{p.pickup_date || '—'}</td>
                  <td className="px-4 py-3 font-semibold text-dark">${p.total.toFixed(2)}</td>
                  <td className="px-4 py-3"><span className={`px-2.5 py-1 rounded-full text-xs font-bold ${badge(p.status)}`}>{p.status}</span></td>
                  <td className="px-4 py-3 text-dark/70">{p.method || '—'}</td>
                  <td className="px-4 py-3 text-dark/70">{p.reference || '—'}</td>
                  <td className="px-4 py-3 text-dark/70">{p.payment_date || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
